@if (certificationDirectusUuids().length) {
  <ul class="list-none">
    @for (certification of certifications(); track certification.id) {
      <li class="mb-2" [attr.data-testid]="'certification-' + $index">
        <app-certification-label [certification]="certification" />
      </li>
    }
  </ul>
} @else {
  <p class="italic text-muted-color" data-testid="no-certifications">
    {{ 'hr-tool.detail.noCertifications' | transloco }}
  </p>
}
